import { tShared, tSharedWith } from "@/shared/i18n/tShared";

/**
 * Тексты касания: ключи shared.attribution.* (сид attribution.ts на
 * бэкенде), русский defaultValue совпадает с сидом и виден в админке.
 */
export const touchTexts = {
  empty: () => tShared("shared.attribution.empty", "Нет данных об источнике"),
  source: () => tShared("shared.attribution.source", "Источник"),
  medium: () => tShared("shared.attribution.medium", "Канал"),
  campaign: () => tShared("shared.attribution.campaign", "Кампания"),
  content: () => tShared("shared.attribution.content", "utm_content"),
  term: () => tShared("shared.attribution.term", "utm_term"),
  link: () => tShared("shared.attribution.link", "Короткая ссылка"),
  email: () => tShared("shared.attribution.email", "Письмо"),
  capturedAt: () => tShared("shared.attribution.capturedAt", "Дата визита"),
  restored: () =>
    tShared("shared.attribution.restored", "Восстановлено по истории"),
  linkValue: (title: string) =>
    tSharedWith("shared.attribution.linkValue", "Короткая ссылка «{{title}}»", {
      title,
    }),
  linkDeleted: (title: string) =>
    tSharedWith(
      "shared.attribution.linkDeleted",
      "Короткая ссылка «{{title}}» (удалена)",
      { title }
    ),
  deletedCampaign: () =>
    tShared("shared.attribution.deletedCampaign", "Удалённая рассылка"),
  broadcast: (name: string) =>
    tSharedWith("shared.attribution.broadcast", "Рассылка «{{name}}»", {
      name,
    }),
  event: (name: string) =>
    tSharedWith("shared.attribution.event", "Автоматизация «{{name}}»", {
      name,
    }),
  journey: (name: string) =>
    tSharedWith("shared.attribution.journey", "Цепочка «{{name}}»", { name }),
  transactional: (template: string) =>
    tSharedWith(
      "shared.attribution.transactional",
      "Служебное письмо ({{template}})",
      { template }
    ),
};
